import React from 'react'
import styles from '../styles/Projects.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { projectsData } from '../data/projectsData'
import '../styles/global.scss'


export const Projects = () => {

    return (
        <div id="projects" className='container'> 
            <h2 className='title'>Projetos</h2>
            {projectsData.map((project) => {
                return (
                <div className={styles.projectContent}>
                    <div className={styles.projectImgContainer}>
                        <img className={styles.projectImg} src={process.env.PUBLIC_URL + project.image} />
                    </div>
                    <div className={styles.projectInfoContainer}>
                        <h3 className={styles.projectTitle}>{project.title}</h3>
                        <p className={styles.projectTech}>{project.tech}</p>
                        <p className={styles.tasksTitle}>Responsabilidades:</p>
                        <ul className={styles.tasksList}>
                            {project.tasks.map((task) => <li>- {task}</li>)}
                        </ul>
                        <a href={project.url} className='cta' target='_blank' rel="noreferrer"><span>Visitar website <FontAwesomeIcon icon={faArrowUpRightFromSquare} className='ctaIcon' /></span></a>
                    </div>
                </div>
                )
            })}
        </div>
    )
}

